<div class="info-page">
  <h3>Demanda de Monitoramento</h3>
</div>

<form [formGroup]="form" (ngSubmit)="salvar()" *ngIf="!isLoading">
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Título<sup class="text-danger ms-2">*</sup></label>
      <input type="text" id="subject" class="form-control" formControlName="subject" />
      <app-field-message [field]="fieldMessageRequired('subject')" [erros]="fieldErros('subject')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Descrição</label>
      <textarea rows="4" id="description" class="form-control" formControlName="description" placeholder="Descrição da Demanda"></textarea>
      <app-field-message [field]="fieldMessageRequired('description')" [erros]="fieldErros('description')"></app-field-message>
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Órgão demandado</label>
      <input type="text" id="agency_name" class="form-control" disabled="true" [value]="entity?.agency_name || infoProjeto?.agency_name" />
    </div>
  </div>
  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Demandado titular</label>
      <ng-select id="manager_main" class="ng-select-alternative" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione o titular" formControlName="manager_main">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('manager_main')" [erros]="fieldErros('manager_main')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Demandado adjunto</label>
      <ng-select id="adjunct" class="ng-select-alternative" [multiple]="true" [items]="usuarioList" bindLabel="label" bindValue="id" placeholder="Selecione" formControlName="adjunct">
      </ng-select>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Situação<sup class="text-danger ms-2">*</sup></label>
      <ng-select id="issue_stat_id" class="ng-select-alternative" [items]="situacaoList" bindLabel="label" bindValue="id" formControlName="issue_stat_id" placeholder="Selecione a Situação">
      </ng-select>
      <app-field-message [field]="fieldMessageRequired('issue_stat_id')" [erros]="fieldErros('issue_stat_id')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Prazo<sup class="text-danger ms-2">*</sup></label>
      <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker formControlName="dt_foreseen_end" [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', locale: 'pt-br' }" placeholder="dd/mm/aaaa" (change)="dataMask($event, 'dt_foreseen_end')">
      <app-field-message [field]="fieldMessageRequired('dt_foreseen_end')" [erros]="fieldErros('dt_foreseen_end')"></app-field-message>
    </div>
  </div>

  <div class="form-group row m-b">
    <div class="col-sm-8">
      <label class="col-sm-12 pb-1">Links</label>
      <a [href]="link" target="_blank">{{ linkLabel }}</a>
    </div>
  </div>

  <div class="hr-line-dashed"></div>
  <div class="form-group row d-flex justify-content-end">
    <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
      <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
      <button class="btn btn-primary" type="submit">Salvar</button>
    </div>
  </div>
</form>
<app-loading [loader]="isLoading"></app-loading>

<div class="col-lg-12 m-t-xl" *ngIf="audit">
  <app-historico-atualizacoes-demandas-monitoramento-list [audit]="audit"></app-historico-atualizacoes-demandas-monitoramento-list>
</div>